// import bluemercury from '../Images/BlueMercury.png' 
// import beyoung from '../Images/BeYoung.png' 
// import WakeHealhty from '../Images/WakeHealthy.png' 
// import ESPN from '../Images/ESPN.png'
import Tripoto from '../assets/Tripoto.png'
import Gusto from '../assets/Gusto.png'

import Meesho from '../assets/Meesho.png'
export const ProjectData = [
    {
        "name": "Shopping Quest",
        "desc": "This is the clone of Amazon website, one of the world's largest e-commerce website which deals with the sales of a huge variety of products.",
        "img": "https://fahad9988.github.io/static/media/shopping-quest.b4884adebd8161bc143c.png",
        "git": "https://github.com/sahilkh07/Shopping-Quest",
        "deploy": "https://shopping-quest.vercel.app/",
        "techStack":[
          {
              "name": "HTML",
              "img": "https://cdn-icons-png.flaticon.com/512/1532/1532556.png"
          },
          {
              "name": "CSS",
              "img": "https://cdn4.iconfinder.com/data/icons/social-media-logos-6/512/121-css3-512.png"
          },
          {
              "name": "JavaScript",
              "img":  "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png"
          
          },
          {
            "name": "React",
            "img": "https://cdn1.iconfinder.com/data/icons/programing-development-8/24/react_logo-512.png"
        },
        {
          "name":"React-Redux",
          "img":"https://santoshy1101.github.io/My-Portfolio/static/media/redux.4ea2c9105f4e7643b31c.png"
        },
        {
          "name": "Chakra UI",
          "img":  "https://camo.githubusercontent.com/eec63163a5209f78e8b0e3d6ab82eb981d03c4453a7a466f4fdc063da09f2a4d/68747470733a2f2f692e696d6775722e636f6d2f454d796b5a62332e706e67"
      },
        {
            "name": "Node.js",
            "img": "https://seeklogo.com/images/N/nodejs-logo-FBE122E377-seeklogo.com.png"
        },
        {
          "name":"Express.js",
          "img":"https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fhackersandslackers-cdn.storage.googleapis.com%2F2020%2F05%2Fexpress.png&f=1&nofb=1&ipt=1ad3cc6707e5365ef9352aea7491609d844a5114647a3a6d250e65e0d22909c3&ipo=images"
  
        },
        {
          "name":"MongoDB",
          'img':"https://www.mongodb.com/assets/images/global/leaf.png"
        }
    
     
        ]
    }
    ,

    {
        "name": "Market Link",
        "desc": "This is the clone of Meesho website, one of the India's largest e-commerce website which deals with the sales of a huge variety of products.",
        "img": Meesho,
        "git": "https://github.com/sahilkh07/Meesho-Clone",
        "deploy": "https://meshoo-clone.vercel.app/",
        "techStack":[
            {
                "name": "HTML",
                "img": "https://cdn-icons-png.flaticon.com/512/1532/1532556.png"
            },
            {
                "name": "CSS",
                "img": "https://cdn4.iconfinder.com/data/icons/social-media-logos-6/512/121-css3-512.png"
            },
            {
                "name": "JavaScript",
                "img":  "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png"
            
            },
            {
              "name": "React",
              "img": "https://cdn1.iconfinder.com/data/icons/programing-development-8/24/react_logo-512.png"
          },
          {
              "name":"React-Redux",
              "img":"https://santoshy1101.github.io/My-Portfolio/static/media/redux.4ea2c9105f4e7643b31c.png"
            },
         
          {
              "name": "Chakra UI",
              "img":  "https://camo.githubusercontent.com/eec63163a5209f78e8b0e3d6ab82eb981d03c4453a7a466f4fdc063da09f2a4d/68747470733a2f2f692e696d6775722e636f6d2f454d796b5a62332e706e67"
          },
          {
              "name":"Tailwind CSS",
              'img':"https://santoshy1101.github.io/My-Portfolio/static/media/tailwind.e47ac876b8d4d0bba47a.png"
          }
        ]
    },
  {
      "name": "Tripoto",
      "desc": "This is a travel website where you can book a lot of travel packages to go around the world, A collabrative team project which we have built using HTML, CSS, JS.",
      "img":Tripoto ,
      "git": "https://github.com/sahilkh07/boundless-sleep-6032",
      "deploy":"https://jovial-babka-946b54.netlify.app/",
      "techStack":[
        {
            "name": "HTML",
            "img": "https://cdn-icons-png.flaticon.com/512/1532/1532556.png"
        },
        {
            "name": "CSS",
            "img": "https://cdn4.iconfinder.com/data/icons/social-media-logos-6/512/121-css3-512.png"
        },
        {
            "name": "JavaScript",
            "img":  "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png"
        
        },
          
      ]
  },
  {
      "name": "Gusto",
      "desc": "A platform helps businesses take care of their hardworking teams. Each year they process tens of billions of dollars of payroll and provide employee benefits—like health insurance and 401(k) accounts—while helping companies create incredible work places. ",
      "img": Gusto,
      "git": "https://github.com/sahilkh07/nostalgic-blood-2749/tree/main/Gusto",
      "deploy": "https://netlify-thinks-sahilkh07-is-great.netlify.app/",
      "techStack":[
        {
            "name": "HTML",
            "img": "https://cdn-icons-png.flaticon.com/512/1532/1532556.png"
        },
        {
            "name": "CSS",
            "img": "https://cdn4.iconfinder.com/data/icons/social-media-logos-6/512/121-css3-512.png"
        },
        {
            "name": "JavaScript",
            "img":  "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png"
        
        },
        {
          "name": "React",
          "img": "https://cdn1.iconfinder.com/data/icons/programing-development-8/24/react_logo-512.png"
      },
     
      {
          "name": "Chakra UI",
          "img":  "https://camo.githubusercontent.com/eec63163a5209f78e8b0e3d6ab82eb981d03c4453a7a466f4fdc063da09f2a4d/68747470733a2f2f692e696d6775722e636f6d2f454d796b5a62332e706e67"
      },
      
          
      ]
  },
 
 
 
 
]